import {Component, OnInit, ViewChild} from '@angular/core';
import { CurrentRouteService } from '../currentRoute.service';
import { Router,ActivatedRoute } from '@angular/router';
import {ApiService} from "../api_service/api.service";
import {AgencyIdService} from "../account.service";
import {AgencysService} from "./agencys.service";
import {AgencyInterfaceData} from "../shared/models/agency.model";
import {Observable} from "rxjs";

//NGRX
import { Agency } from '../shared/models/agency.model';
import {Store} from "@ngrx/store";
import * as fromApp from "../store/app.reducer";
import * as AgencyListActions from "./store/agencys.actions";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import * as AccountListActions from "../accounts/store/accounts.actions";
import {DeleteAccountRowDialog} from "../accounts/accounts.component";
import {RoleService} from "../role.service";


export interface AgencyModel {
  Id: string;
  agency_id: string;
  name: string;
}


@Component({
  selector: 'app-agencys',
  templateUrl: './agencys.component.html',
  styleUrls: ['./agencys.component.css']
})
export class AgencysComponent implements OnInit {


  helps = []

  is_table_column_hidden: boolean = true;
  agency_idx_hash:any = {};
  agencys_hash:any = {}
  agencys:any = [];
  is_loading:boolean = false;
  role:string;

  dataSource: MatTableDataSource<AgencyInterfaceData>;
  displayedColumns: string[] = ['name', 'View', 'Edit', 'Delete', 'star'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(public router: Router,
              private currentrouteService: CurrentRouteService,
              private agencyidService: AgencyIdService,
              private route: ActivatedRoute,
              private _apiService: ApiService,
              private agencysService: AgencysService,
              private roleService: RoleService,
              private store: Store<fromApp.AppState>
   ) { }

  agencys$: Observable<Agency[]> = this.store.select(state => state.agencyList.agencys);
  //error$: Observable<null | string> = this.store.select(state => state.accountList.error);
  loading$: Observable<boolean> = this.store.select(state => state.agencyList.loading);


  ngOnInit(): void {
    localStorage.removeItem('agency_id');

    let role_sub = this.roleService.roleAnnounced$.subscribe(
      role => {
        this.role = role;
      }
    ); //end role_sub


    console.log(this.router.url);
    this.currentrouteService.announceCurrentRoute(this.router.url);
    this.loadUser()

    //this.loadAgencys()

  } //end ngOnInit

  loadUser(){
    this.is_loading = true;
    let role = localStorage.getItem('role');
    if (role=='admin'){
      let endpoint = 'user/self';
      this.agencysService.getUserSelf(endpoint).subscribe((data )  => {
          console.log('user data',data)
          this.loadAgencys()
        },
        error => {
          console.log(error)
          this.is_loading = false
        });
    }
    if (role=='superadmin'){
      this.loadAgencys()
    }



  } //end loadUser


  loadAgencys(){
    this.is_loading = true;
    let role = localStorage.getItem('role');


    if (role=='admin'){
      let endpoint = 'agency/self';
      //let endpoint = `agency?email=${email}`;
      this.agencysService.getAgency(endpoint).subscribe((data )  => {
          let agency_name = data.name
          let agency_id = data.agency_id;
          localStorage.setItem('agency_id',agency_id);
          this.agencyidService.announceAgencyId(agency_id);
          this.router.navigate(['accounts',agency_id],{ queryParams: { agency_name: agency_name }});
        },
        error => {
          console.log(error)
          this.is_loading = false
        });
    } //end admin

    if (role=='superadmin'){
      let email = localStorage.getItem('email');
      let endpoint = `agency?email=${email}`;

      this.store.dispatch({ type: AgencyListActions.LOAD_AGENCYS, payload: endpoint});

      this.agencys$.subscribe(data => {
        console.log('EFFETCT from compoment',data);
      });

      this.agencysService.getAgencys(endpoint).subscribe((data:AgencyInterfaceData[])  => {
          this.agency_idx_hash = {};
          this.agencys_hash = {}
          this.agencys = [];
          for (let _i = 0; _i < data.length; _i++) {
            this.agencys_hash[data[_i].agency_id] = data[_i];
            this.agency_idx_hash[data[_i].agency_id] = _i;
            let temp = {};
            temp['Id'] = data[_i].agency_id;
            temp['name'] = data[_i].name;
            temp['Delete'] = '';
            temp['Edit'] = '';
            this.agencys.push(temp)
          }
          this.dataSource = new MatTableDataSource(this.agencys);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.is_loading=false
        },
        error => {
          this.is_loading=false
          console.log(error)
        });

    } //end superadmin
  } //end loadAgencys

  addAgency(is_edit,rid){

  }

  viewData(row) {
    let agency_id = row['Id']
    let agency_name = row['name']

    localStorage.setItem('agency_id', agency_id);
    //this.accountnameService.announceAccountName(account_name)
    //this.accountidService.announceAccountId(account_id)
    this.router.navigate(['/accounts', agency_id],{ queryParams: { agency_name: agency_name }}); // { queryParams: { account_name: account_name }}relativeTo: this.route,

  } //end viewData(row)

  getTableRecord(row) {
  } // end getTableRecord( )

  deleteRow(account_id) {

    // const dialogRef = this.dialog.open(DeleteAccountRowDialog, {});
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result == 'cancel') {
    //     //do nothing
    //   } else {
    //     const index = this.account_idx_hash[account_id]
    //     let endpoint = `account/${account_id}`;
    //     console.log('DELETE ACCOUNT!!!!!!!!', {endpoint:endpoint, index: index})
    //     console.log(this.account_idx_hash)
    //     this.store.dispatch({ type: AccountListActions.LOAD_DELETE_ACCOUNT, payload: {endpoint:endpoint, index: index}})
    //     //this.loadAccounts(this.agency_id)
    //     // this._apiService.deleteApiData(endpoint).subscribe(x => {
    //     //   this.loadAccounts(this.agency_id)
    //     // });
    //   }
    // });//end dialogRef.afterClosed()

  } //deleteRow



} //end class
